import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { ScrollArea } from "@/components/ui/scroll-area";
import { Video, User, Phone } from "lucide-react";

/**
 * PatientList - Patient selection list for starting calls
 */
export default function PatientList({ patients = [], onStartCall }) {
  const handlePhoneCall = (patient) => {
    const phoneNumber = patient.phone || patient.patient_phone;
    if (phoneNumber) {
      // Clean phone number and initiate click-to-call
      const cleanPhone = phoneNumber.replace(/\D/g, '');
      window.location.href = `tel:${cleanPhone}`;
    } else {
      // Show notification that no phone number is available
      alert(`No phone number on file for ${patient.patient_name || patient.name}. Please add a phone number to their profile.`);
    }
  };

  return (
    <Card>
      <CardHeader>
        <CardTitle className="text-lg">Start Call</CardTitle>
        <CardDescription>Select a patient from your caseload</CardDescription>
      </CardHeader>
      <CardContent>
        <ScrollArea className="h-64">
          <div className="space-y-2">
            {patients.length === 0 ? (
              <p className="text-sm text-muted-foreground text-center py-8">
                No patients in your caseload
              </p>
            ) : (
              patients.map((patient) => (
                <div
                  key={patient.id}
                  className="flex items-center gap-2 p-2 rounded-lg border hover:bg-muted/50 transition-colors"
                >
                  <div className="w-10 h-10 rounded-full bg-primary/10 flex items-center justify-center flex-shrink-0">
                    <User className="w-5 h-5 text-primary" />
                  </div>
                  <div className="text-left flex-1 min-w-0">
                    <p className="font-medium truncate">{patient.patient_name || patient.name}</p>
                    <p className="text-xs text-muted-foreground truncate">
                      {patient.diagnosis || "Patient"} 
                      {patient.phone && <span className="ml-1">• {patient.phone}</span>}
                    </p>
                  </div>
                  <div className="flex items-center gap-1 flex-shrink-0">
                    <Button
                      variant="outline"
                      size="icon"
                      className="h-8 w-8"
                      onClick={() => handlePhoneCall(patient)}
                      title="Phone Call"
                      data-testid={`phone-patient-${patient.id}`}
                    >
                      <Phone className="w-4 h-4 text-blue-600" />
                    </Button>
                    <Button
                      variant="outline"
                      size="icon"
                      className="h-8 w-8"
                      onClick={() => onStartCall(patient)}
                      title="Video Call"
                      data-testid={`video-patient-${patient.id}`}
                    >
                      <Video className="w-4 h-4 text-green-600" />
                    </Button>
                  </div>
                </div>
              ))
            )}
          </div>
        </ScrollArea>
      </CardContent>
    </Card>
  );
}
